import { DateFormats, formatJSDate } from '@omnipresentgroup/design-system';

export const getDateForPayload = (date: string): string => {
  if (!date) {
    return '';
  }
  return formatJSDate(new Date(date), DateFormats.FixedDate, true);
};
